import { Card } from '@/components/ui/card';
import { useAuth } from '@/hooks/useAuth';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/logout')({
  component: RouteComponent,
})

function RouteComponent() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    Promise.resolve(signOut())
      .then(() => {
        navigate({ to: '/' });
      })
      .catch((error) => {
        console.error('Error during sign out:', error);
        navigate({ to: '/' });
      });
  }, [signOut, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <Card className="w-[350px] p-6">
        <div className="text-center">
          <h2 className="text-lg font-semibold mb-2">Logging out</h2>
          <p className="text-muted-foreground">Please wait...</p>
        </div>
      </Card>
    </div>
  );
}
